document.addEventListener('DOMContentLoaded', function() {
  const lightboxLinks = document.querySelectorAll('[data-fancybox="gallery"]');
  lightboxLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      const videoUrl = this.getAttribute('href');
      $.fancybox.open({
        src: videoUrl,
        type: 'iframe'
      });
    });
  });
});